/**
 * NOTE:
 * - R6 June [established:新設]
 */

import { t } from "i18next"
import { Version, getCurrentVersion } from "@project/shared"
import { Moment } from "moment"
import { FormFieldsProp } from "../../../../molecules/FormFields/types"

type Params = {
  name: string
}

function buildOptions(options: [string, string][]) {
  return options.map(([label, value]) => ({ label, value }))
}

/**
 * Version management: Facility Status Form
 * @param {Moment} date
 * @param {Params} params
 * @return {FormFieldsProp|null}
 */
export function getWelfareCareStaffTreatmentImprovement(
  date: Moment,
  params: Params
) {
  const { version } = getCurrentVersion(date.format("YYYY-MM-DD"))

  switch (version) {
    case Version.BASELINE:
    case Version.R6_APRIL:
      return null

    case Version.R6_JUNE:
    case Version.R7_JANUARY:
      return r6June(params.name)

    case Version.R8_JUNE:
      return r8June(params.name)

    case Version.R7_APRIL:
    default:
      return r7April(params.name)
  }
}

/**
 * --------------------------------
 * @version R7_APRIL
 * --------------------------------
 */

function r7April(name: string): FormFieldsProp {
  return {
    // TODO: translate
    fieldLabel: "福祉・介護職員等処遇改善",
    isRowFlexed: true,
    isShown: true,
    fields: [
      {
        name,
        fieldType: {
          type: "radio",
          extraOptions: {
            option: buildOptions([
              [t("No"), "0"],
              [t("I"), "11"],
              [t("II"), "12"],
              [t("III"), "13"],
              [t("IV"), "14"],
            ]),
          },
        },
      },
    ],
  }
}

/**
 * --------------------------------
 * @version R6_JUNE,R7_JANUARY
 * --------------------------------
 */

function r6June(name: string): FormFieldsProp {
  return {
    // TODO: translate
    fieldLabel: "福祉・介護職員等処遇改善",
    isRowFlexed: true,
    isShown: true,
    fields: [
      {
        name,
        fieldType: {
          type: "radio",
          extraOptions: {
            option: buildOptions([
              [t("No"), "0"],
              [t("I"), "11"],
              [t("II"), "12"],
              [t("III"), "13"],
              [t("IV"), "14"],
            ]),
          },
        },
      },
      {
        name,
        fieldType: {
          type: "radio",
          extraOptions: {
            option: buildOptions([
              [t("V(1)"), "21"],
              [t("V(2)"), "22"],
              [t("V(3)"), "23"],
              [t("V(4)"), "24"],
              [t("V(5)"), "25"],
              [t("V(6)"), "26"],
              [t("V(7)"), "27"],
              [t("V(8)"), "28"],
              [t("V(9)"), "29"],
              [t("V(10)"), "30"],
              [t("V(11)"), "31"],
              [t("V(12)"), "32"],
              [t("V(13)"), "33"],
              [t("V(14)"), "34"],
            ]),
          },
        },
      },
    ],
  }
}

/**
 * --------------------------------
 * @version R8_JUNE
 * 令和8年6月 報酬改定 処遇改善加算 新区分（'41'-'46'）
 * - 加算Ⅰ(イ) '41' / 加算Ⅰ(ロ) '42' / 加算Ⅱ(イ) '43' / 加算Ⅱ(ロ) '44' / 加算Ⅲ '45' / 加算Ⅳ '46'
 * - V経過措置（'21'-'34'）は本バージョンでは選択肢から除外（廃止予定、要先方確認）
 * - 設計書: easyy-docs/reforms/202606/kids/設計/共通_新区分コード体系.md §1, §3
 * --------------------------------
 */

function r8June(name: string): FormFieldsProp {
  return {
    // TODO: translate
    fieldLabel: "福祉・介護職員等処遇改善",
    isRowFlexed: true,
    isShown: true,
    fields: [
      {
        name,
        fieldType: {
          type: "radio",
          extraOptions: {
            option: buildOptions([
              [t("No"), "0"],
              ["Ⅰ(イ)", "41"],
              ["Ⅰ(ロ)", "42"],
              ["Ⅱ(イ)", "43"],
              ["Ⅱ(ロ)", "44"],
              ["Ⅲ", "45"],
              ["Ⅳ", "46"],
            ]),
          },
        },
      },
    ],
  }
}

/**
 * --------------------------------
 * @version BASELINE
 * @version R6_APRIL
 *
 * NONE
 * --------------------------------
 */
